<div class="_vbox _sidebar">
  <dt-sidebar-brand-logo></dt-sidebar-brand-logo>
  <section class="overflow-y-auto flex-grow pt-3">
    <ul class="p-2 m-0 overflow-hidden">
      <li>
        <a
          [routerLink]="['/', 'admin', 'profile']"
          routerLinkActive="active-link"
        >
          <i class="{{ PrimeIcons.USER }}"></i>
          <span>Profile</span>
        </a>
      </li>
      <li>
        <a
          [routerLink]="['/', 'admin', 'teams']"
          routerLinkActive="active-link"
        >
          <i class="{{ PrimeIcons.USERS }}"></i>
          <span>Teams</span>
        </a>
      </li>
      <li>
        <a
          [routerLink]="['/', 'admin', 'workspaces']"
          routerLinkActive="active-link"
        >
          <i class="{{ PrimeIcons.WAREHOUSE }}"></i>
          <span>Workspaces</span>
        </a>
      </li>
      <!--      <li>-->
      <!--        <a-->
      <!--          [routerLink]="['/', 'admin', 'branches']"-->
      <!--          routerLinkActive="active-link"-->
      <!--        >-->
      <!--&lt;!&ndash;          <i class="{{ PrimeIcons.BRA }}"></i>&ndash;&gt;-->
      <!--          <fa-icon [icon]="['fas', 'code-branch']"></fa-icon>-->
      <!--          <span>Branches</span>-->
      <!--        </a>-->
      <!--      </li>-->
    </ul>
  </section>

  <section>
    <dt-sidebar-footer [hideUpgradeButton]="true"></dt-sidebar-footer>
  </section>
</div>
